define.alias("shared/components/shared/addon-details-card/upcoming-plan", "preview-grid/components/shared/addon-details-card/upcoming-plan");